import React, { useMemo } from "react";
import { Link, useRouteError } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignInAlt } from "@fortawesome/free-solid-svg-icons";
import { getRandomDog } from "./DogSvgs";
import "./ErrorPage.css";

const ERROR_MESSAGES = {
  404: {
    title: "Página no encontrada",
    message: "Parece que esta página se fue a pasear y no ha vuelto. Verifica que la dirección sea correcta.",
  },
  500: {
    title: "Error del servidor",
    message: "Algo salió mal en nuestro servidor. Nuestro equipo ya fue notificado, intenta de nuevo en unos minutos.",
  },
  default: {
    title: "Algo salió mal",
    message: "Ocurrió un error inesperado. No te preocupes, puedes volver a iniciar sesión.",
  },
};

// Hook seguro: useRouteError lanza si se usa fuera de errorElement context
const useSafeRouteError = () => {
  try {
    return useRouteError();
  } catch {
    return null;
  }
};

const ErrorPage = ({ errorCode, errorTitle, errorMessage }) => {
  const routeError = useSafeRouteError();

  const code = errorCode || routeError?.status || "Error";
  const config = ERROR_MESSAGES[code] || ERROR_MESSAGES.default;
  const title = errorTitle || config.title;
  const message = errorMessage || routeError?.statusText || config.message;

  const RandomDog = useMemo(() => getRandomDog(), []);

  return (
    <div className="error-page">
      <div className="error-page__card">
        <div className="error-page__dog-container">
          <RandomDog />
        </div>

        <div className="error-page__code">{code}</div>
        <h1 className="error-page__title">{title}</h1>
        <p className="error-page__message">{message}</p>

        <Link to="/authentication/split/login" className="error-page__btn">
          <FontAwesomeIcon icon={faSignInAlt} />
          Ir al inicio de sesión
        </Link>

        <div className="error-page__footer">
          QuroReports &bull; Sistema de reportes y análisis
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
